/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getAssessmentQuestions } from 'app/entities/assessment-question/assessment-question.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getPreAssessments } from 'app/entities/pre-assessment/pre-assessment.reducer';
import { createEntity, getEntity, reset, updateEntity } from './assessment-answer.reducer';

export const AssessmentAnswerUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const assessmentQuestions = useAppSelector(state => state.assessmentQuestion.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const preAssessments = useAppSelector(state => state.preAssessment.entities);
  const assessmentAnswerEntity = useAppSelector(state => state.assessmentAnswer.entity);
  const loading = useAppSelector(state => state.assessmentAnswer.loading);
  const updating = useAppSelector(state => state.assessmentAnswer.updating);
  const updateSuccess = useAppSelector(state => state.assessmentAnswer.updateSuccess);

  const handleClose = () => {
    navigate(`/assessment-answer${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getAssessmentQuestions({}));
    dispatch(getGlucoUsers({}));
    dispatch(getPreAssessments({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...assessmentAnswerEntity,
      ...values,
      question: assessmentQuestions.find(it => it.id.toString() === values.question?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      preAssessment: preAssessments.find(it => it.id.toString() === values.preAssessment?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...assessmentAnswerEntity,
          question: assessmentAnswerEntity?.question?.id,
          patient: assessmentAnswerEntity?.patient?.id,
          preAssessment: assessmentAnswerEntity?.preAssessment?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.assessmentAnswer.home.createOrEditLabel" data-cy="AssessmentAnswerCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.assessmentAnswer.home.createOrEditLabel">Create or edit a AssessmentAnswer</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="assessment-answer-id"
                  label={translate('tinyMedicRestApp.assessmentAnswer.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.assessmentAnswer.answer')}
                id="assessment-answer-answer"
                name="answer"
                data-cy="answer"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.assessmentAnswer.comment')}
                id="assessment-answer-comment"
                name="comment"
                data-cy="comment"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.assessmentAnswer.active')}
                id="assessment-answer-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.assessmentAnswer.cursor')}
                id="assessment-answer-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.assessmentAnswer.lastupdated')}
                id="assessment-answer-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.assessmentAnswer.microSec')}
                id="assessment-answer-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.assessmentAnswer.timestampentry')}
                id="assessment-answer-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                id="assessment-answer-question"
                name="question"
                data-cy="question"
                label={translate('tinyMedicRestApp.assessmentAnswer.question')}
                type="select"
                required
              >
                <option value="" key="0" />
                {assessmentQuestions
                  ? assessmentQuestions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="assessment-answer-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.assessmentAnswer.patient')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="assessment-answer-preAssessment"
                name="preAssessment"
                data-cy="preAssessment"
                label={translate('tinyMedicRestApp.assessmentAnswer.preAssessment')}
                type="select"
                required
              >
                <option value="" key="0" />
                {preAssessments
                  ? preAssessments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/assessment-answer" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AssessmentAnswerUpdate;
